export default __webpack_public_path__ + "static/media/pt-br.d8eeb163.png";